import { render } from "./order_upload.vue?vue&type=template&id=6774fe7c&scoped=true"
import script from "./order_upload.vue?vue&type=script&lang=js"
export * from "./order_upload.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6774fe7c"]])

export default __exports__